import { render, staticRenderFns } from "./systemSettings.vue?vue&type=template&id=5444224a&scoped=true"
import script from "./systemSettings.vue?vue&type=script&lang=js"
export * from "./systemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444224a",
  null
  
)

export default component.exports